/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsExchange = createReactComponent("outline", "arrows-exchange", "IconArrowsExchange", [["path", { "d": "M7 10h14l-4 -4", "key": "svg-0" }], ["path", { "d": "M17 14h-14l4 4", "key": "svg-1" }]]);

export { IconArrowsExchange as default };
//# sourceMappingURL=IconArrowsExchange.mjs.map
